import { render, staticRenderFns } from "./VueBottomSheet.vue?vue&type=template&id=0208c6a0&scoped=true&"
import script from "./VueBottomSheet.vue?vue&type=script&lang=js&"
export * from "./VueBottomSheet.vue?vue&type=script&lang=js&"
import style0 from "./VueBottomSheet.vue?vue&type=style&index=0&id=0208c6a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208c6a0",
  null
  
)

export default component.exports